/* Create a new observer instance */
document.addEventListener('DOMContentLoaded', function () {
// Select the entire DOM for observing:

  // Call the below function
  var country_iso_code = document.getElementById("country_iso_code");
  console.log(country_iso_code.value);
  if(country_iso_code.value == "AT"){

    for(let i=0; i< document.getElementsByClassName("block-swatch__item").length; i++){
        document.getElementsByClassName("block-swatch__item")[i].addEventListener('click', myFunction);
      }

    function myFunction() {
      setTimeout(function (){
  
         var price = document.getElementsByClassName("product-form__info-content")[0].getElementsByClassName("price-list")[0].innerHTML.replace(/<[^>]*>?/gm, '').replace("Sale price", "").replace("€", "").replace(".", ",");
            
              var price_int = parseFloat(price);
               if(price != ""){
                 price_int = price_int * 1.2;
                 var price_str = "€"+price_int.toFixed(2).replace(".", ",");
                 document.getElementsByClassName("product-form__info-content")[0].getElementsByClassName("price-list")[0].innerHTML = '<span class="price"><span class="visually-hidden">Sale price</span>'+price_str+'</span>';
               }
                  
      }, 200); // How 
     
    }

    /*


    function setPrice(){
      setTimeout(() => {
          console.log("set price");
          const upsell_price = document.getElementsByClassName("lb-upsell-money-2");
          for (let i = 0; i < upsell_price.length; i++) {
            var price = upsell_price[i].innerHTML.replace("€", "").replace(".", ",");
            console.log(price);
            if(price.toLowerCase().indexOf("included") === -1) {
               console.log(price);
              var price_int = parseFloat(price);
               if(price != ""){
                 price_int = price_int * 1.2;
                 var price_str = "€"+price_int.toFixed(2).replace(".", ",")+" Tax included";
                 upsell_price[i].innerHTML = price_str;
               }
            }
            
    
          }
      }, 500);

    }
  
    waitForElementToDisplay(".lb-upsell-ppa-card-cont",function(){
      
      
      setPrice();
      
      for(let i=0; i< document.getElementsByClassName("lb-spc-details-name").length; i++){
        document.getElementsByClassName("lb-spc-details-name")[i].addEventListener('click', doThing);
      }
      
      for(let i=0; i< document.getElementsByClassName("lb-spc-cursor-pointer").length; i++){
        document.getElementsByClassName("lb-spc-cursor-pointer")[i].addEventListener('click', setPrice);
      }
      
      
      
      function doThing(){
        
        waitForElementToDisplay(".ppa-prod-details-price",function(){
          console.log(document.getElementsByClassName("ppa-prod-details-price").length);
          console.log(document.getElementsByClassName("ppa-prod-details-price")[0]);
          
          var price = document.getElementsByClassName("lb-prod-prev-price")[0].getElementsByClassName("lb-upsell-money-2")[0].innerHTML.replace("€", "").replace(".", ",");
          var price_int = parseFloat(price);
           if(price != ""){
             price_int = price_int * 1.2;
             var price_str = "€"+price_int.toFixed(2).replace(".", ",")+" Tax included";
             document.getElementsByClassName("lb-prod-prev-price")[0].getElementsByClassName("lb-upsell-money-2")[0].innerHTML = price_str;
           }
         
        },1000,2000);
      }
      
      
      
                                                          
                                                            
     },1000,8000);
*/
}

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
  var startTimeInMs = Date.now();
  (function loopSearch() {
    if (document.querySelector(selector) != null) {
      callback();
      return;
    }
    else {
      setTimeout(function () {
        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
          return;
        loopSearch();
      }, checkFrequencyInMs);
    }
  })();
}
  
       
}, false);


function waitForAttachments() {
    const attachments = document.querySelector('.tigren-attachments');
    const block = document.querySelector('.tigren-product-attachments');

    if (!attachments || !block) {
        setTimeout(waitForAttachments, 100);
        return;
    }

    if (attachments.innerHTML.trim() === '') {
        block.style.display = 'none';
    }
}

document.addEventListener('DOMContentLoaded', waitForAttachments);